import { type UseQueryResult, useQuery } from 'react-query';
import {
  OpenAPI,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_FairValue_FairValueImportParseDto,
} from '@wealthlane/api-services/wealthlane-award-service';
import axios from 'axios';
import { skipDecimalConversion } from '../../utils/apiDecimalConfig';
import { CancelablePromise } from '@wealthlane/api-services/wealthlane-award-service';

export interface FairValueByVestingDatePayload {
  awardType?: string;
  awardId: string;
  vestingDateId: string;
}

const getFairValueByVestingDate = (
  payload: FairValueByVestingDatePayload
  // eslint-disable-next-line camelcase
): CancelablePromise<Wealthlane_AwardService_Dtos_FairValue_FairValueImportParseDto> => {
  return new CancelablePromise(async (resolve, reject) => {
    try {
      const response = await axios.get(
        `${OpenAPI.BASE}/api/award/api/app/fair-value/fair-value-by-vesting-date`,
        {
          params: {
            AwardType: payload.awardType,
            AwardId: payload.awardId,
            VestingDateId: payload.vestingDateId,
          },
          headers: {
            Authorization: `Bearer ${OpenAPI.TOKEN ?? ''}`,
            ...(typeof OpenAPI.HEADERS === 'object' ? OpenAPI.HEADERS : {}),
          },
        }
      );
      resolve(response.data);
    } catch (error: any) {
      reject(error?.response?.data ?? error);
    }
  });
};

const useGetFairValueByVestingDate = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  payload: FairValueByVestingDatePayload,
  enabled = true
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_FairValue_FairValueImportParseDto | undefined,
  unknown
> => {
  return useQuery(
    ['getFairValueByVestingDate', payload.awardId, payload.vestingDateId],
    async () => {
      return await handleRequest(
        skipDecimalConversion(getFairValueByVestingDate(payload))
      );
    },
    {
      enabled: enabled && !!payload.awardId && !!payload.vestingDateId,
    }
  );
};

export { getFairValueByVestingDate };
export default useGetFairValueByVestingDate;
